<template>
  <Sidebar collapsible="icon" class="aside-sidebar-dark tw:border-r-0 tw:group-data-[side=left]:border-r-0">
    <SidebarHeader class="tw:p-0 tw:gap-0">
      <div class="tw:flex tw:h-[65px] tw:items-center tw:bg-white tw:px-[22px] tw:group-data-[collapsible=icon]:justify-center tw:group-data-[collapsible=icon]:px-2">
        <Skeleton class="tw:h-[35px] tw:w-32 tw:animate-pulse tw:group-data-[collapsible=icon]:size-5" />
      </div>
    </SidebarHeader>
    <SidebarContent>
      <SidebarGroup class="tw:px-0 tw:py-[15px]">
        <SidebarGroupContent>
          <SidebarMenu class="tw:list-none tw:m-0 tw:p-0 tw:gap-0">
            <SidebarMenuItem v-for="i in 8" :key="i">
              <div class="tw:flex tw:h-11 tw:items-center tw:gap-3.5 tw:px-[25px]">
                <Skeleton class="tw:size-5 tw:shrink-0 tw:animate-pulse tw:bg-white/8" />
                <!-- Collapsed rail: match the real sidebar, labels hide and icons keep their spot. -->
                <Skeleton
                  class="tw:h-4 tw:animate-pulse tw:bg-white/8 tw:group-data-[collapsible=icon]:hidden"
                  :style="{ width: `${50 + ((i * 17) % 41)}%` }"
                />
              </div>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
  </Sidebar>
</template>

<script setup lang="ts">
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
} from '@/shadcn/components/ui/sidebar'
import { Skeleton } from '@/shadcn/components/ui/skeleton'

defineOptions({
  name: 'AsideSkeleton',
})
</script>
